export default __webpack_public_path__ + "static/media/DPOS-400.86fbc5d3.pdf";